/**
 * The Notification Popup.
 *
 * It uses js-cookie as Cookies:
 * @link https://github.com/js-cookie/js-cookie
 * @link https://www.npmjs.com/package/js-cookie
 * > npm install js-cookie --save
 */

import Cookies from 'js-cookie';

$(() => {
  // Find the notification modal
  const $modal = $('#website-modal-notification');
  if ($modal.length) {
    let cookieName = $modal.attr('data-cookie-name');
    let timeout = parseFloat($modal.attr('data-timeout'));
    let delay = parseFloat($modal.attr('data-delay'));
    const $modalMobile = $('#website-modal-notification-mobile');
    const $modalMobileBtn = $modalMobile.find('.modal-button');
    let isMobile = $(window).width() < 559;

    // Get the notification cookie
    let notificationWasShowed = cookieName ? Cookies.get(cookieName) : '';

    // If the notification was not showed
    if (notificationWasShowed !== 'true') {
      // Init the modal
      $modal.modal({ show: false });
      // Init modal mobile
      if ($modalMobile.length) $modalMobile.modal({ show: false });

      // Show the modal
      setTimeout(() => {
        // Modal mobile exist
        if ($modalMobile.length && isMobile) {
          $modalMobile.modal('show');
        } else {
          $modal.modal('show');
        }
      }, delay);

      // Close mobile preview + open full modal
      $modalMobileBtn.on('click', function () {
        $modalMobile.modal('hide');
        $modal.modal('show');
      });

      // Update the cookie
      if (cookieName && timeout) {
        Cookies.set(cookieName, 'true', { expires: timeout });
      } else {
        Cookies.remove(cookieName);
      }
    }
  }
});
